export function LogoMark({ className = "h-10 w-10", id = "lm" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true" data-testid="logo-mark">
      <defs>
        <linearGradient id={`${id}-gold`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#E3C36E" />
          <stop offset="0.5" stopColor="#C9A24A" />
          <stop offset="1" stopColor="#8F6D24" />
        </linearGradient>
        <linearGradient id={`${id}-navy`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#152A4F" />
          <stop offset="1" stopColor="#0B1730" />
        </linearGradient>
      </defs>
      <polygon points="50,3 91,26.5 91,73.5 50,97 9,73.5 9,26.5" fill={`url(#${id}-navy)`} stroke={`url(#${id}-gold)`} strokeWidth="3" strokeLinejoin="miter" />
      <polygon points="50,12 83,31 83,69 50,88 17,69 17,31" fill="none" stroke="#C9A24A" strokeOpacity="0.45" strokeWidth="1" />
      <path
        fillRule="evenodd"
        fill={`url(#${id}-gold)`}
        d="M33 29 H55 A21 21 0 0 1 55 71 H33 Z M43 38 V62 H54 A12 12 0 0 0 54 38 Z"
      />
      <rect x="28" y="47.5" width="9" height="5" fill={`url(#${id}-navy)`} />
    </svg>
  );
}

export function Logo({ markClass = "h-10 w-10", nameClass = "text-base sm:text-lg", showTagline = true, id = "logo", testid = "brand-logo" }) {
  return (
    <span className="flex items-center gap-3" data-testid={testid}>
      <LogoMark className={`${markClass} shrink-0`} id={id} />
      <span className="flex flex-col leading-none">
        <span className={`font-brand font-extrabold tracking-tight text-slate-50 ${nameClass}`} data-testid={`${testid}-name`}>
          DEFCOIN <span className="font-semibold text-slate-400">Ltd.</span>
        </span>
        {showTagline && (
          <span className="mt-1 font-mono text-[8px] sm:text-[9px] tracking-[0.22em] uppercase text-[#C9A24A]" data-testid={`${testid}-tagline`}>
            Defense &amp; Advanced Technology Solutions
          </span>
        )}
      </span>
    </span>
  );
}
